export const itemType = (item) => {
    if (!item.submenu) return 'menu';
    if (item.submenu) return 'submenu';
};
